import { AxiosPromise } from 'axios'
import axios from '../../utils/axios'

export function readAppConfig() {
  return axios({
    method: 'GET',
    url: '/init.json',
  })
}

export function readRedirectFrom(from: string, domain: string) {
  return axios({
    panelApi: true,
    method: 'POST',

    url: '/api/redirects/search',
    data: {
      from,
      domain,
    },
  })
}

export function readTranslations(languageCode: string) {
  return axios({
    panelApi: true,
    method: 'GET',
    url: '/api/translation/file.json?tag=b2c.front&language=' + languageCode,
  })
}
